export default "__VITE_ASSET__a806d0a0__"